import React from "react";
import { useContext, useEffect, useRef, useState } from "react";
import { css, ThemeContext } from "styled-components";
import ToastContext from "./ToastContext";
import composeRefs from "@seznam/compose-react-refs";
import { SuccessMd, WarningMd } from "../icons";
import { replaceToken } from "../../private/helpers";
import { ToastContainer, openCloseBase, quickCloseAnimation, closeSwap, ToastElement, IconContainer, ActionButton, MessageContainer } from "./styles";
var Toast = _ref => {
  var {
    activeToast,
    requestClose
  } = _ref;
  var {
    removeToast
  } = useContext(ToastContext);
  var theme = useContext(ThemeContext);
  var toastRef = useRef(null);
  var {
    message,
    action,
    variant = "success",
    placement = "bottom",
    offset = "medium",
    className,
    style,
    ref,
    dangerouslySetClassNames
  } = activeToast;
  var offsetString = replaceToken(theme == null ? void 0 : theme.spacing, offset);
  var [quickClose, setQuickClose] = useState(false);
  useEffect(() => {
    var toast = toastRef.current;
    if (!toast) return;
    toast.addEventListener("animationend", requestClose || removeToast);
    return () => toast.removeEventListener("animationend", requestClose || removeToast);
  }, [requestClose, removeToast]);
  var getAnimation = () => {
    if (requestClose) return css(["animation:", " 100ms forwards;"], closeSwap(placement, offsetString));else if (quickClose) return css(["animation:", " 300ms;"], quickCloseAnimation);
    return css(["animation:", " 6s forwards;"], openCloseBase(placement));
  };
  return /*#__PURE__*/React.createElement(ToastContainer, {
    $placement: placement,
    $offset: offsetString,
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(ToastElement, {
    key: message,
    ref: composeRefs(ref, toastRef),
    $animation: getAnimation(),
    $action: !!action,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.toastElement,
    role: "alert"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    $variant: variant,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.iconContainer
  }, variant === "warning" ? /*#__PURE__*/React.createElement(WarningMd, null) : /*#__PURE__*/React.createElement(SuccessMd, null)), /*#__PURE__*/React.createElement(MessageContainer, null, message), action && /*#__PURE__*/React.createElement(ActionButton, {
    variant: "naked",
    sizeVariant: "medium",
    compact: true,
    onClick: () => {
      action.onClick();
      setQuickClose(true);
    },
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.actionButton
  }, action.label)));
};
export default Toast;